import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import {
  useStore
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/toolbar/toolbar-store.ts
import * as Core from "@ariakit/core/toolbar/toolbar-store";
function useToolbarStoreOptions(props) {
  return useCompositeStoreOptions(props);
}
function useToolbarStoreProps(store, props) {
  return useCompositeStoreProps(store, props);
}
function useToolbarStore(props = {}) {
  const options = useToolbarStoreOptions(props);
  const store = useStore(
    () => Core.createToolbarStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useToolbarStoreProps(store, props);
}
export {
  useToolbarStore,
  useToolbarStoreOptions,
  useToolbarStoreProps
};
